"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitializedPlugins = exports.getEnabledPlugins = exports.enablePlugins = void 0;
var constants_1 = require("./constants");
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/**
 * Enables all plugins that need manual enablement
 *
 * @param enabledPlugins default plugins that are enabled
 */
var enablePlugins = function enablePlugins(enabledPlugins) {
  enabledPlugins.forEach(function (plugin) {
    if (plugin.enablePlugin !== undefined) {
      plugin.enablePlugin();
    }
  });
};
exports.enablePlugins = enablePlugins;
/**
 * Filters the combined object maps for just the enabled plugins
 *
 * @param pluginConfiguration - plugin configuration options passed in by the user
 */
var getEnabledPlugins = function getEnabledPlugins() {
  var pluginConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var map = getPluginMap(pluginConfiguration.defaultPluginConfigurationOverrides);
  var enabledDefaultPlugins = Object.values(map).filter(function (plugin) {
    return plugin.enabled;
  });
  if (pluginConfiguration.additionalPlugins !== undefined) {
    return [].concat(_toConsumableArray(enabledDefaultPlugins), _toConsumableArray(pluginConfiguration.additionalPlugins));
  }
  return enabledDefaultPlugins;
};
exports.getEnabledPlugins = getEnabledPlugins;
/**
 * Creates the BrowserPlugin[] list to be instantiated in the Snowplow tracker
 *
 * @param enabledPlugins default plugins that are enabled
 */
var getInitializedPlugins = function getInitializedPlugins(enabledPlugins) {
  return enabledPlugins.map(function (plugin) {
    if (plugin.plugin !== undefined) {
      return plugin.plugin();
    }
    return {};
  });
};
exports.getInitializedPlugins = getInitializedPlugins;
/**
 * Combines the default plugins map with a user supplied override, if one is present
 *
 * @param defaultPluginOverrides - any overrides to the default plugins passed in by the user
 */
var getPluginMap = function getPluginMap() {
  var defaultPluginOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, lodash_merge_1["default"])(constants_1.DEFAULT_PLUGINS, defaultPluginOverrides);
};